import React from 'react';
import { FC } from 'react';

export const Nonplussed: FC = () => {
    return (
        <div>
            <div> 
                <iframe 
                title="Slide" 
                src="https://docs.google.com/presentation/d/e/2PACX-1vSIXeHq6R3he-hKBX22CmX8ub_GzMBBTiohTChB4vsJAPg3ViT0DcRVlSBUl_9Xgho3r6_0XwSVPZ5b/embed?start=false&loop=false&delayms=3000"
                width="1200" height="675">
                </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};